module.exports = __webpack_public_path__ + "0406a7b2485b3366c75dc7afc188be43.svg";